"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.saveRecordings = exports.saveRecording = exports.fetchRecordings = exports.fetchAntecedents = exports.deleteRecording = void 0;
const utils_1 = require("./utils");
Object.defineProperty(exports, "deleteRecording", { enumerable: true, get: function () { return utils_1.deleteRecording; } });
Object.defineProperty(exports, "fetchAntecedents", { enumerable: true, get: function () { return utils_1.fetchAntecedents; } });
Object.defineProperty(exports, "fetchRecordings", { enumerable: true, get: function () { return utils_1.fetchRecordings; } });
Object.defineProperty(exports, "saveRecording", { enumerable: true, get: function () { return utils_1.saveRecording; } });
Object.defineProperty(exports, "saveRecordings", { enumerable: true, get: function () { return utils_1.saveRecordings; } });
